import { render } from "./ui-number.vue?vue&type=template&id=4b07e4f3&ts=true"
import script from "./ui-number.vue?vue&type=script&lang=ts"
export * from "./ui-number.vue?vue&type=script&lang=ts"

import "./ui-number.vue?vue&type=style&index=0&id=4b07e4f3&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__